






























import { Component, Vue, Prop } from "vue-property-decorator";
import store from "@/store";
import { AppConstants } from "../core/Export";
@Component({
  components: {}
})
export default class RedRouteStepQuestions extends Vue {
  @Prop() questionModel;
  @Prop() onSetQuestionAnswer: Function;
  constructor() {
    super();
  }

  created() {}

  onUpdateTrueValue() {
    this.questionModel.answer = true;
    this.onSetQuestionAnswer();
  }

  onUpdateFalseValue() {
    this.questionModel.answer = false;
    this.onSetQuestionAnswer();
  }

  onGetMapRadioOptions() {
    let arr = this.questionModel.answerList;
    return arr.map(e => {
      return { label: e.text, value: e.id };
    });
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
